<template lang="pug">
  .component-backoffice-category-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true",)
</template>

<script>
import GoogleMap from '../../lib/map/GoogleMap'
import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
import BaseList from './BaseList'
import ModalReveal from "../../components/structure/foundation/ModalReveal.vue";
import {mapState} from "vuex";
import collect from "collect.js";
import ActionButton from "../../components/structure/ui/ActionButton.vue";
import Editor from "../../components/structure/ui/Editor.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

export default {
  name: 'PageConfigList',
  components: {Editor, ActionButton, ModalReveal, BaseList, GoogleMap, GoogleMapPolygon},
  data() {
    return {
      component: require('src/components/backoffice/Page.vue'),

      pages: [],

    }
  },
  created() {
  },
  methods: {
    dataLoader(callback, page, resultsPerPage) {
      return KeplerBackofficeSdk.pages.list(page, resultsPerPage).all((data) => {
        callback(data)
      })
    },
  },
}
</script>

<style scoped lang="sass">
.component-backoffice-zone-list
  .map
    height: 400px

  .zone-edit
    color: white

</style>



// WEBPACK FOOTER //
// PageConfigList.vue?deca81e0